import { ActionStore } from 'ynf-core-engine/stores'

export default class NewTreeStore extends ActionStore {
  constructor(props: any) {
    super()
  }
}